import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { urls } from "../../../../../urls";

const validSteps = ["info", "procedure", "summary"] as const;
export type PublicEventStep = (typeof validSteps)[number];

export const useStepNavigation = (eventId: string) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rawStep = searchParams.get("step");
  const currentStep: PublicEventStep | null = validSteps.includes(rawStep as PublicEventStep)
    ? (rawStep as PublicEventStep)
    : null;

  useEffect(() => {
    if (!currentStep) {
      navigate(urls.publicEvents.edit.go(eventId).info);
    }
  }, [currentStep, eventId, navigate]);

  const navigateToStep = (step: PublicEventStep) => {
    navigate(urls.publicEvents.edit.go(eventId)[step]);
    window.scrollTo(0, 0);
  };

  return {
    currentStep,
    navigateToInfo: () => navigateToStep("info"),
    navigateToProcedure: () => navigateToStep("procedure"),
    navigateToSummary: () => navigateToStep("summary"),
  };
};
